import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_MUNICIPIOS_COLETA,
  SET_ESTADOS_COLETA,
  SET_PESO,
  SET_VALOR_MERCADORIA,
  SET_SELECTED_SORT,
  SET_MUNICIPIOS_ENTREGA,
  SET_ESTADOS_ENTREGA,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_MUNICIPIOS_COLETA](state, searchText) {
    state.municipiosColeta = searchText;
  },
  [SET_MUNICIPIOS_ENTREGA](state, searchText) {
    state.municipiosEntrega = searchText;
  },
  [SET_ESTADOS_COLETA](state, searchText) {
    state.estadosColeta = searchText;
  },
  [SET_ESTADOS_ENTREGA](state, searchText) {
    state.estadosEntrega = searchText;
  },
  [SET_PESO](state, searchText) {
    state.peso = searchText;
  },
  [SET_VALOR_MERCADORIA](state, searchText) {
    state.valorMercadoria = searchText;
  },
  [SET_SELECTED_SORT](state, selectedSort) {
    state.selectedSort = selectedSort;
  },
};
